
import { RouterTools } from "@/common/RouterTools";
import { ActionType } from "@/pages/check/CheckPage";
import { RootMutationNames } from "@/vuex-store";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class HomeIntroduce extends Vue {
  readonly appVersion: string = process.env.PACKAGE_VERSION;

  // 定价方案
  PriceClick() {
    RouterTools.pushTo("pay");
  }
  // 锚点 跳到产品介绍
  productClick(selector: any) {
    this.$el.querySelector(selector).scrollIntoView();
  }
  // 立即注册
  registerClick() {
    this.$store.commit(RootMutationNames.setShowLoginPanel, true);
  }
  // 立即试用
  TryNowClick() {
    this.$router.push("./home");
  }
  // 合作方案锚点 跳到联系我们
  CooperationClick(selector: any) {
    this.$el.querySelector(selector).scrollIntoView();
  }
  // 试用语法纠错
  UseCorrectionClick() {
    this.$router.push("./check");
  }
  // 前往工作台
  workClick() {
    this.$router.push("./writing");
  }
  // 查看范文
  lookClick() {
    this.$router.push({
      name: RouterTools.pageNames.check,
      params: { type: ActionType.example + "" },
    });
  }
}
